module.exports = {
  generator: require('./mp4-generator'),
  Transmuxer: require('./transmuxer').Transmuxer,
  AudioSegmentStream: require('./transmuxer').AudioSegmentStream,
  VideoSegmentStream: require('./transmuxer').VideoSegmentStream
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mux.js/lib/mp4/index.js
// module id = fYOu
// module chunks = 2